<div class="enrich-card" *ngIf="visible">
  <div class="enrich-card__header">
    <span class="enrich-card__title">
      {{ 'quotations_and_orders.enrich_company_emails.title' | translate }}
    </span>
    <span class="enrich-card__badge">
      {{ 'quotations_and_orders.enrich_company_emails.suggested_rule' | translate }}
      <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
    </span>
  </div>

  <div class="enrich-card__row">
    <span class="enrich-card__label">
      {{ 'quotations_and_orders.enrich_company_emails.suffix_desc' | translate }}
    </span>
    <div class="standard-input">
      <select class="enrich-card__select" [(ngModel)]="selectedEmail" [disabled]="isSaving">
        <option *ngFor="let email of options" [value]="email">{{ email }}</option>
      </select>
    </div>
  </div>

  <div class="enrich-card__row">
    <span class="enrich-card__label">
      {{ 'quotations_and_orders.enrich_company_emails.prefix_desc' | translate }}
    </span>
    <a class="enrich-card__company-badge" target="_blank" [routerLink]="['/companies', company?.main_location_id]">
      <ui-svg-icon svgIcon="company_icon" size="medium"></ui-svg-icon>
      <span>{{ company?.name }}</span>
    </a>
  </div>

  <div class="enrich-card__row" *ngIf="selectableLocations.length">
    <span class="enrich-card__label">
      {{ 'quotations_and_orders.enrich_company_emails.shipping_location' | translate }}
    </span>
    <div class="standard-input">
      <select
        class="enrich-card__select"
        [(ngModel)]="selectedLocationId"
        (ngModelChange)="onLocationChange()"
        [disabled]="isSaving">
        <option [ngValue]="null">
          {{ 'quotations_and_orders.enrich_company_emails.no_location' | translate }}
        </option>
        <option *ngFor="let location of selectableLocations" [ngValue]="location.id">
          {{ locationLabel(location) }}
        </option>
      </select>
    </div>
  </div>

  <p class="enrich-card__disclaimer">
    {{ 'quotations_and_orders.enrich_company_emails.disclaimer' | translate }}
  </p>

  <hr class="enrich-card__divider" />

  <div class="enrich-card__actions">
    <ui-button
      type="danger"
      [label]="'quotations_and_orders.enrich_company_emails.discard' | translate"
      [disabled]="isSaving"
      (click)="discard()">
    </ui-button>
    <ui-button
      type="primary"
      [label]="'quotations_and_orders.enrich_company_emails.save' | translate"
      [isLoading]="isSaving"
      (click)="save()">
    </ui-button>
  </div>
</div>
